import * as React from "react";

import { cn } from "../../libs/cn";

export function Textarea({ className, ...props }: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      className={cn(
        "min-h-24 w-full resize-none rounded-2xl bg-[var(--color-surface)] px-4 py-3 text-base ring-1 ring-[var(--color-line)] outline-none placeholder:text-[var(--color-muted)] focus:ring-2 focus:ring-[var(--color-accent)]",
        className,
      )}
      {...props}
    />
  );
}
